var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_413_34527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 24.6663C14.532 24.6682 16.0497 24.3673 17.4654 23.7809C18.8811 23.1945 20.167 22.3341 21.2492 21.2492C22.3341 20.167 23.1945 18.8811 23.7809 17.4654C24.3673 16.0497 24.6682 14.532 24.6663 12.9997C24.6682 11.4673 24.3673 9.94968 23.7809 8.53397C23.1945 7.11826 22.3341 5.83237 21.2492 4.75018C20.167 3.66528 18.8811 2.80489 17.4654 2.21847C16.0497 1.63204 14.532 1.33113 12.9997 1.33302C11.4673 1.33113 9.94968 1.63204 8.53397 2.21847C7.11826 2.80489 5.83237 3.66528 4.75018 4.75018C3.66528 5.83237 2.80489 7.11826 2.21847 8.53397C1.63204 9.94968 1.33113 11.4673 1.33302 12.9997C1.33113 14.532 1.63204 16.0497 2.21847 17.4654C2.80489 18.8811 3.66528 20.167 4.75018 21.2492C5.83237 22.3341 7.11826 23.1945 8.53397 23.7809C9.94968 24.3673 11.4673 24.6682 12.9997 24.6663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 13L11.833 16.5L18.833 9.5",
    stroke: "black",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_413_34527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 -1H27V27H-1V-1Z",
    fill: "#008000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/CheckMarkIcon.cc7d56f1c3320202c8198a9ae8ee54ad.svg";
export { ForwardRef as ReactComponent };